var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"catalog-page"},[_c('h1',{staticClass:"mt-0 mb-2"},[_vm._v("Gem Pages")]),_c('CatalogPages')],1)}
var staticRenderFns = []

export { render, staticRenderFns }